// extracted by css-extract-rspack-plugin
export default {"icon":"_5e4ec6c9"};